// extracted by mini-css-extract-plugin
export default {"component":"coins_component__RCmnu","popUp":"coins_popUp__2Vk+K"};